import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ManulaAllotement } from "../../CrudOperations/PostOperation";
import {
  getAllArea,
  getAllStaff,
  GetAvailableStaffs,
  getCommunities,
  getDuttyAllotement,
  getEventList,
  getStaffSkillList,
} from "../../CrudOperations/GetOperation";
import { updateDutyAllotementInDatabase } from "../../CrudOperations/Update&Edit";

const ManulaAllotementModal = ({ ManualAllotementData, closeModal }) => {
  ManualAllotementData;


  const [showConfirmModal, setShowConfirmModal] = useState(false);
const [pendingReplacement, setPendingReplacement] = useState({
  index: null,
  oldStaffId: null,
  newStaffId: null,
});


  const [EventDetailedId, setEventDetailedId] = useState(
    ManualAllotementData || ""
  );

  const [ExistingStaffIn_database, setExistingStaffInDataBase] = useState([]);
  const [Replace_staffId_for_database, setReplace_staff_id_forDataBase] =
    useState({});

  useEffect(() => {
    Replace_staffId_for_database;
  }, [Replace_staffId_for_database]);

  const [AreaId, setAreaId] = useState("");

  const [AreaList, setAreaList] = useState([]);
  const [StaffSkillList, setStaffSkillList] = useState([]);
  const [EventDetailsList, setEventDetailsList] = useState([]);
  const [staffList, setstaffList] = useState([]);
  const [filterStaffList, setFilterstaffList] = useState([]);
  const [AllotedDeputies, setAllotedDeputiesList] = useState([]);
  const [communityList, setCommunityList] = useState([]);
  const [numberOfDeputation, setNumberOfDeputation] = useState(0);

  const [staffIds, setstaffIds] = useState([]);
  const [ReplaceMentEnabled, setReplaceMentEnabled] = useState(false);
  const [ReplaceMap, setReplaceMap] = useState({});

  useEffect(() => {
    const fetchStaffs = async () => {
      const [
        Area,
        StaffsKill,
        EventDetails,
        allotedDeputies,
        Communities,
        staffList,
      ] = await Promise.all([
        getAllArea(),
        getStaffSkillList(),
        getEventList(),
        getDuttyAllotement(),
        getCommunities(),
        getAllStaff(),
      ]);

      if (allotedDeputies?.data?.Message === "Success") {
        setAllotedDeputiesList(allotedDeputies.data.AllottedDeputies);
      }

      if (staffList?.data?.Message === "Success") {
        setstaffList(staffList.data.Data);
        setFilterstaffList(staffList.data.Data);
      }

      if (Area?.data?.Message === "Success") {
        const filteredAreas = Area.data.Data.filter(
          (ele) => ele.EventDetailId === ManualAllotementData
        );
        setAreaList(filteredAreas);
      }

      if (EventDetails?.data?.Message === "Success") {
        setEventDetailsList(EventDetails.data.Data);
      }

      if (Communities?.data?.Message === "Success") {
        setCommunityList(Communities.data.Data);
      }

      if (StaffsKill?.data?.Message === "Success") {
        setStaffSkillList(StaffsKill.data.Data);
      }
    };
    fetchStaffs();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!ReplaceMentEnabled) {
      const response = await ManulaAllotement(
        parseInt(AreaId),
        ManualAllotementData,
        staffIds,
        ReplaceMentEnabled
      );
      if (response?.data?.ServerMessage === "Manual allotment completed.") {
        toast.success(response?.data?.ServerMessage);
        closeModal();
      } else {
        toast.warn(response?.data?.message);
      }
    } else {
      const response = await updateDutyAllotementInDatabase(
        parseInt(AreaId),
        ManualAllotementData,
        staffIds,
        ReplaceMentEnabled,
        ReplaceMap
      );

      if (response?.data?.ServerMessage === "Manual allotment completed.") {
        toast.success(response?.data?.ServerMessage);
        closeModal();
      } else {
        toast.warn(response?.data?.message);
      }
    }
  };

  //   const handleAreaChange = async (e) => {

  //     const value = parseInt(e.target.value) || 0;
  //     setAreaId(value);

  //     const response = await GetAvailableStaffs(value);
  // console.log(response);

  //       const staffs = response?.data?.Staff;
  //     const TotalNeeded = response?.data?.TotalNeeded;

  //     const RemainingCount = response?.data?.RemainingCount;

  //      console.log(staffs);

  //      if(staffs?.length < 0){
  //               setReplaceMentEnabled(false);
  //      }

  //     const selectedArea = AreaList.find((area) => area.AreaId === value);

  //          console.log(selectedArea);

  //     if (selectedArea) {
  //       const updatedStaffIds = staffs?.map((element) => element.StaffId) || [];

  //       if (updatedStaffIds.length <= 0) {
  //         const dummyIds = Array.from(
  //           { length: TotalNeeded },
  //           (_, i) => "new_" + i
  //         );
  //         setReplaceMentEnabled(false);
  //         setstaffIds(dummyIds);
  //         setNumberOfDeputation(TotalNeeded);
  //         return;
  //       }

  //       let filledStaffIds = updatedStaffIds;

  //       // if (TotalNeeded > updatedStaffIds.length) {
  //       //   const remainingSlots = TotalNeeded - updatedStaffIds.length;

  //       //   // Fill the remaining slots with empty strings
  //       //   filledStaffIds = updatedStaffIds.concat(Array(remainingSlots).fill(""));

  //       // }

  //       //  it is ..
  //       setstaffIds(filledStaffIds);
  //       //  it is ..

  //       setNumberOfDeputation(selectedArea.NoOfDeputation);
  //       setExistingStaffInDataBase(staffs);
  //     }

  //   };

  const handleAreaChange = async (e) => {
    const value = parseInt(e.target.value) || 0;
    setAreaId(value);

    try{

    const response = await GetAvailableStaffs(value);
    console.log(response);

    if(response?.data?.Message === "Error"){

      toast.error(response?.data?.Message + " " + "Please Contact With Backend Team!")
      toast.error(response?.data?.ServerMessage + " " + "Please Contact With Backend Team!")



      return 
    }

    let staffs = response?.data?.Staff;
    const TotalNeeded = response?.data?.TotalNeeded;

    console.log(TotalNeeded);

    const updatedStaffIds = staffs?.map((element) => element.StaffId) || [];
   console.log(staffs);
    if (staffs.length <= 0) {

      console.log(staffs);
      
      const array = [];

      while (array.length < TotalNeeded) {
        array.push("");
      }

      console.log(array);

      setstaffIds(array);
      setNumberOfDeputation(TotalNeeded);
    } else {
      setReplaceMentEnabled(true);

      console.log(staffs);

      const data = staffs.map((ele) => ele.StaffId);
      console.log(data);

      setstaffIds(data);

      setNumberOfDeputation(TotalNeeded);
    }

  }
  catch(error){
    toast.error(error?.response?.data?.message || error?.response?.data?.ServerMessage)

  }


  };

const handleStaffChange = (index, staffId = null, value) => {
  const updatedValue = parseInt(value);

  if (ReplaceMentEnabled && staffIds[index] && staffIds[index] !== updatedValue) {
    setPendingReplacement({
      index,
      oldStaffId: staffIds[index],
      newStaffId: updatedValue,
    });
    setShowConfirmModal(true);
    return;
  }

  // Normal flow if not replacing
  setstaffIds((prev) => {
    const updated = [...prev];
    updated[index] = updatedValue;
    return updated;
  });
};


  useEffect(() => {
    staffIds;
  }, [staffIds]);

  const handleCheckboxChange = (e) => {
    if (ReplaceMentEnabled) {
      toast.warn(
        "Cannot check this. Deputies are already fully or partially allotted. Please add or replace from the list below."
      );
    } else {
      toast.warn("Replacement not allowed. Please allot manually first!");
    }
    // setIsReplacement(e.target.checked);
    "Replacement checked:", e.target.checked;
  };



  const handleConfirmReplacement = async () => {

    try {
  const { index, oldStaffId, newStaffId } = pendingReplacement;

  const updatedStaffIds = [...staffIds];
  updatedStaffIds[index] = newStaffId;
  setstaffIds(updatedStaffIds);

  // Update the replace map for DB
  setReplaceMap((prev) => ({
    ...prev,
    [oldStaffId]: newStaffId,
  }));

  try{

  // Directly update DB
  const response = await updateDutyAllotementInDatabase(
    parseInt(AreaId),
    ManualAllotementData,
    updatedStaffIds,
    true,
    { [oldStaffId]: newStaffId }
  );

  if (response?.data?.ServerMessage) {

      toast.success(response?.data?.message || response?.data?.ServerMessage);

  } else {
    toast.warn(response?.data?.message || "Replacement failed.");
  }

  setShowConfirmModal(false);
  setPendingReplacement({ index: null, oldStaffId: null, newStaffId: null });

}
catch(error){
 toast.error(error?.response?.data?.message || error?.response?.data?.ServerMessage  || "Replacement failed.");

}


}
catch(error){

  console.log(error);
  

}
};

const handleCancelReplacement = () => {
  setShowConfirmModal(false);
  setPendingReplacement({ index: null, oldStaffId: null, newStaffId: null });
};


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75">
      <div className="bg-white rounded-lg p-4 w-1/3 shadow-lg">
        <div className="flex justify-between">
          <h2 className="text-lg font-bold mb-3">Manual Allot Deputy</h2>

          <div>
            <input
              onChange={handleCheckboxChange}
              type="checkbox"
              id="manualAllot"
              checked={ReplaceMentEnabled}
            />
            <label htmlFor="manualAllot" className="ml-2">
              Replacement
            </label>
          </div>
        </div>

        <form onSubmit={handleFormSubmit}>
          <div className="mb-2">
            <label className="block text-gray-700">Event *</label>
            <select
              disabled
              value={EventDetailedId}
              className="border border-gray-300 p-1 w-full rounded-md"
            >
              <option value="">Select Event</option>
              {EventDetailsList.map((event) => (
                <option key={event.EventDetailId} value={event.EventDetailId}>
                  {event.EventName}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Area *</label>
            <select
              value={AreaId}
              onChange={handleAreaChange}
              className="border border-gray-300 p-1 w-full rounded-md"
            >
              <option value="">Select Area</option>
              {AreaList.map((area) => (
                <option key={area.AreaId} value={area.AreaId}>
                  {area.AreaName}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">No. Of Deputations *</label>
            <input
              disabled
              type="number"
              value={numberOfDeputation}
              className="border border-gray-300 p-1 w-full rounded-md"
            />
          </div>

          {staffIds?.map((staffId, index) => (
            <div key={index} className="mb-2">
              <label className="block text-gray-700">Select Deputy</label>
              <select
                value={staffId}
                onChange={(e) =>
                  handleStaffChange(index, staffId, e.target.value)
                }
                className="border border-gray-300 p-1 w-full rounded-md"
              >
                <option value="">Select Staff</option>
                {filterStaffList.map((staff) => (
                  <option key={staff.StaffId} value={staff.StaffId}>
                    {staff.FullName} - {staff.CommunityName}
                  </option>
                ))}
              </select>
            </div>
          ))}

          <div className="flex justify-end">
            <button
              type="button"
              onClick={closeModal}
              className="bg-gray-300 px-3 py-1 rounded-md mr-2"
            >
              Cancel
            </button>
            {!ReplaceMentEnabled && (
              <button
                type="submit"
                className="bg-blue-600 text-white px-3 py-1 rounded-md"
              >
                Submit
              </button>
            )}
          </div>
        </form>
      </div>


      {showConfirmModal && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="bg-white rounded-lg p-4 shadow-lg w-[300px]">
      <p className="text-lg mb-4">
        Are you sure you want to replace this deputy?
      </p>
      <div className="flex justify-end space-x-2">
        <button
          onClick={handleCancelReplacement}
          className="bg-gray-300 px-3 py-1 rounded"
        >
          Cancel
        </button>
        <button
          onClick={handleConfirmReplacement}
          className="bg-red-600 text-white px-3 py-1 rounded"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
)}



    </div>
  );
};

export default ManulaAllotementModal;
